// @ts-check

/** @type {import("@liquidweb-dev/club-sauce/public/asset/index.raw").LWApiPublicAssetDetailsParamsRawI['alsowith']} */
const hostingDetailsAlsowith = [
	'altGroup',
	'nocworxRemoteDetails',
	'creation_date',
	'price',
	'privateParent',
	'featureDetails',
	'categories',
	'capabilities',
	'networkSummary',
	'children',
	'backupsAndStorage',
	'resourceState',
	'diskDetails',
	'mesDetails',
	'powerStatus',
	'zone',
	'instance',
	'machine',
	'region',
	'template',
	'templateApp',
	'custom_description',
];

export default hostingDetailsAlsowith;
